// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../generated-types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetViewTourByUuidQueryVariables = Types.Exact<{
  UUID: Types.Scalars["ID"];
}>;

export type GetViewTourByUuidQuery = {
  __typename?: "Query";
  getTourByUUID: {
    __typename?: "Tour";
    ID: number;
    UUID: string;
    name: string;
    status: Types.TourStatus;
    photoURL?: string | null;
    description?: string | null;
    duration?: number | null;
    updatedAt: any;
    logo?: string | null;
    contract: {
      __typename?: "Contract";
      status?: Types.ContractStatus | null;
      name: string;
    };
    scenes: Array<{
      __typename?: "Scene";
      ID: number;
      UUID: string;
      name: string;
      narrative?: string | null;
      description?: string | null;
      bucketVideoURL?: string | null;
      updatedAt: any;
      muxPlaybackID?: string | null;
      status: Types.SceneStatus;
      reelID: string;
      estDuration?: number | null;
      actualDuration?: number | null;
      rotationSpeed: number;
      tourScene?: {
        __typename?: "TourScene";
        ID: number;
        displayOrder: number;
      } | null;
      tour?: {
        __typename?: "Tour";
        name: string;
        contract: { __typename?: "Contract"; name: string };
      } | null;
      model?: {
        __typename?: "MatterportModel";
        ID: number;
        photoURL?: string | null;
        matterportID: string;
        name: string;
        reels: Array<{
          __typename?: "MatterportReel";
          ID: string;
          photoURL: string;
          label: string;
        }>;
      } | null;
    }>;
  };
};

export type DisplaySceneFragment = {
  __typename?: "Scene";
  ID: number;
  UUID: string;
  name: string;
  narrative?: string | null;
  description?: string | null;
  bucketVideoURL?: string | null;
  updatedAt: any;
  muxPlaybackID?: string | null;
  status: Types.SceneStatus;
  reelID: string;
  estDuration?: number | null;
  actualDuration?: number | null;
  rotationSpeed: number;
  tourScene?: {
    __typename?: "TourScene";
    ID: number;
    displayOrder: number;
  } | null;
  tour?: {
    __typename?: "Tour";
    name: string;
    contract: { __typename?: "Contract"; name: string };
  } | null;
  model?: {
    __typename?: "MatterportModel";
    ID: number;
    photoURL?: string | null;
    matterportID: string;
    name: string;
    reels: Array<{
      __typename?: "MatterportReel";
      ID: string;
      photoURL: string;
      label: string;
    }>;
  } | null;
};

export type DisplayTourFragment = {
  __typename?: "Tour";
  ID: number;
  UUID: string;
  name: string;
  status: Types.TourStatus;
  photoURL?: string | null;
  description?: string | null;
  duration?: number | null;
  updatedAt: any;
  logo?: string | null;
  contract: {
    __typename?: "Contract";
    status?: Types.ContractStatus | null;
    name: string;
  };
  scenes: Array<{
    __typename?: "Scene";
    ID: number;
    UUID: string;
    name: string;
    narrative?: string | null;
    description?: string | null;
    bucketVideoURL?: string | null;
    updatedAt: any;
    muxPlaybackID?: string | null;
    status: Types.SceneStatus;
    reelID: string;
    estDuration?: number | null;
    actualDuration?: number | null;
    rotationSpeed: number;
    tourScene?: {
      __typename?: "TourScene";
      ID: number;
      displayOrder: number;
    } | null;
    tour?: {
      __typename?: "Tour";
      name: string;
      contract: { __typename?: "Contract"; name: string };
    } | null;
    model?: {
      __typename?: "MatterportModel";
      ID: number;
      photoURL?: string | null;
      matterportID: string;
      name: string;
      reels: Array<{
        __typename?: "MatterportReel";
        ID: string;
        photoURL: string;
        label: string;
      }>;
    } | null;
  }>;
};

export const DisplaySceneFragmentDoc = gql`
  fragment DisplayScene on Scene {
    ID
    UUID
    name
    narrative
    description
    bucketVideoURL
    updatedAt
    muxPlaybackID
    status
    tourScene {
      ID
      displayOrder
    }
    tour {
      name
      contract {
        name
      }
    }
    model {
      ID
      photoURL
      matterportID
      name
      reels {
        ID
        photoURL
        label
      }
    }
    reelID
    estDuration
    actualDuration
    rotationSpeed
  }
`;
export const DisplayTourFragmentDoc = gql`
  fragment DisplayTour on Tour {
    ID
    UUID
    name
    status
    photoURL
    description
    duration
    updatedAt
    logo
    contract {
      status
      name
    }
    scenes {
      ...DisplayScene
    }
  }
  ${DisplaySceneFragmentDoc}
`;
export const GetViewTourByUuidDocument = gql`
  query GetViewTourByUUID($UUID: ID!) {
    getTourByUUID(UUID: $UUID) {
      ...DisplayTour
    }
  }
  ${DisplayTourFragmentDoc}
`;

export function useGetViewTourByUuidQuery(
  options: Omit<Urql.UseQueryArgs<GetViewTourByUuidQueryVariables>, "query">
) {
  return Urql.useQuery<GetViewTourByUuidQuery>({
    query: GetViewTourByUuidDocument,
    ...options,
  });
}
